// libs
import get from 'lodash/get';

// helpers
import DTM from 'shared/helpers/DTM';

const CHANNEL = 'NDS';

export const getProductData = (skuData: {}) => {
  const title = get(skuData, 'title', '');
  const subTitle = get(skuData, 'subTitle', '');
  const productId = get(skuData, 'id', '');
  const sku = get(skuData, 'sku', '');
  const parentSku = get(skuData, 'parentSku', '');
  const categoryName = get(skuData, 'categoryName', '');
  const sizeName = get(skuData, 'sizeName', '');
  let price = get(skuData, 'price', '');
  let salePrice = get(skuData, 'discountedPrice', '');

  return {
    sku,
    parentSku,
    price,
    salePrice,
    sizeName,
    pagename: `${CHANNEL} : ${title} ${subTitle}`,
    brand: title,
    category: categoryName,
    child_product_id: productId,
  };
};

export const updateAnalyticalData = (skuData: {}) => {
  const modifiedData = getProductData(skuData);
  DTM.updateDatalayer(modifiedData);
};
